module.exports = __webpack_public_path__ + "img/iconsMenu.127d364b.png";